/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SenderUpsertRequest
 */
export interface SenderUpsertRequest {
    /**
     * 
     */
    phone: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    note?: string | null;
    /**
     * 
     */
    active?: boolean;
}

/**
 * Check if a given object implements the SenderUpsertRequest interface.
 */
export function instanceOfSenderUpsertRequest(value: object): value is SenderUpsertRequest {
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SenderUpsertRequestFromJSON(json: any): SenderUpsertRequest {
    return SenderUpsertRequestFromJSONTyped(json, false);
}

export function SenderUpsertRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SenderUpsertRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'],
        'name': json['name'],
        'note': json['note'] === undefined ? undefined : json['note'] === null ? null : json['note'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function SenderUpsertRequestToJSON(json: any): SenderUpsertRequest {
    return SenderUpsertRequestToJSONTyped(json, false);
}

export function SenderUpsertRequestToJSONTyped(value?: SenderUpsertRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone': value['phone'],
        'name': value['name'],
        'note': value['note'],
        'active': value['active'],
    };
}

